import { useState } from 'react'
import { useTexte } from '../../texte'

import { useSaveSettings, useSettings } from '../../hooks/queries'
import { ausEinstellungen, fuerServer, type Listensatz } from '../../lib/listenfarben'
import { Listenwahl } from './Listenwahl'

/**
 * Die **Voreinstellung** für die Farben der Reiseübersicht (#54).
 *
 * Aus dem Betrieb: „Admin stellt ein für alle, einzelne können überschreiben."
 * Diese Karte steht deshalb in der Verwaltung; die Karte daneben
 * (`Listenfarben`) steht bei jedem und gewinnt, solange dort etwas steht.
 *
 * **Und die Frage aus dem Issue ist beantwortet:** „wie geht das bei 2
 * Admins?" — es gibt genau *eine* Voreinstellung. Wer Verwaltung ist,
 * bearbeitet denselben Wert; zwei Admins sind zwei Hände am selben Regler,
 * keine zwei Regler.
 */
export function ListenfarbenCard() {
  const t = useTexte()
  const settings = useSettings()
  const save = useSaveSettings()
  const [gemeldet, setGemeldet] = useState(false)

  const daten = settings.data
  // Ohne Decke ist dieses Konto keine Verwaltung -- der Server hat entschieden.
  if (!daten?.ceiling) return null

  return (
    <div className="card card--seite">
      <h2 className="card__titel">{t.bausteine.farbnamen.liste}</h2>
      <Listenwahl
        lead={t.farben.listeVorgabeLead}
        werte={ausEinstellungen(daten.settings)}
        leerText={t.farben.automatisch}
        alleText={t.farben.allesAutomatisch}
        laeuft={save.isPending}
        fehler={
          save.isError
            ? save.error instanceof Error
              ? save.error.message
              : t.allgemein.schiefgelaufen
            : null
        }
        gemeldet={gemeldet}
        onSpeichern={async (satz: Listensatz) => {
          setGemeldet(false)
          await save.mutateAsync(fuerServer(satz))
          setGemeldet(true)
        }}
      />
    </div>
  )
}
